import { memo as m, useMemo as p } from "react";
import { Shape as i } from "three";
import { jsx as t } from "react/jsx-runtime";
const n = m(function({
  points: s,
  ...a
}) {
  const h = p(() => {
    const o = new i();
    for (let r = 0; r < s.length; r++) {
      let e = s[r];
      "isVector2" in e && (e = [e.x, e.y]), r === 0 ? o.moveTo(e[0], e[1]) : o.lineTo(e[0], e[1]);
    }
    return o.closePath(), o;
  }, [s]);
  return /* @__PURE__ */ t("mesh", {
    ...a,
    children: /* @__PURE__ */ t("shapeGeometry", {
      args: [h]
    })
  });
});
n.displayName = "Shape";
export {
  n as Shape
};
//# sourceMappingURL=index2.js.map
